


























import { Component, Prop, Vue } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'

import * as constants from '@/constants'

import { Category, PantryItem } from '@/datastore/models'

import AddToShoppingListModal from '../modals/AddToShoppingListModal.vue'

import auth from '@/store/modules/auth'
import grocery from '@/store/modules/grocery'

@Component({
	components: {
		AddToShoppingListModal,
		UiButton,
	},
})
export default class PantryListItem extends Vue {

	$refs!: {
		'add-to-shopping-list-modal': AddToShoppingListModal
	}

	@Prop({ required: true })
	readonly category!: Category

	@Prop({ required: true })
	readonly item!: PantryItem

	isAdding = false

	get isInShoppingList(): boolean {

		return grocery.shoppingListItems.some(i => i.pantryItemId === this.item.$id)
	}

	get user(): firebase.UserInfo | null {

		return auth.user
	}

	async doAddToShoppingList(): Promise<void> {

		const { notes, preferredBrands, quantity } = this.$refs['add-to-shopping-list-modal']

		this.isAdding = true

		await grocery.addShoppingListItem({
			createdAt: Date.now(),
			createdBy: this.user?.uid,
			name: this.item.name,
			notes,
			pantryItemId: this.item.$id,
			preferredBrands,
			quantity,
		})

		this.isAdding = false
	}

	mounted() {

		if (this.item.$id === sessionStorage.getItem(constants.sessionStorage.ACTIVE_PANTRY_ITEM_ID)) {
			Vue.nextTick(() => {
				setTimeout(() => {
					const absoluteElementTop = this.$el.getBoundingClientRect().top + window.pageYOffset
					const middle = absoluteElementTop - (window.innerHeight / 2)
					window.scrollTo({ behavior: 'smooth', top: middle })
				}, 100)
			})
		}
	}

	async onAddToShoppingList(): Promise<void> {

		this.$refs['add-to-shopping-list-modal'].show()
	}

	onClick(): void {

		sessionStorage.setItem(constants.sessionStorage.ACTIVE_PANTRY_ITEM_ID, this.item.$id)
	}

	async removeFromCategory(): Promise<void> {

		const { $id: categoryId } = this.category
		const { $id: pantryItemId } = this.item

		await grocery.removePantryItemFromCategory({ categoryId, pantryItemId })
	}

}

